import axios from 'axios';
import { clearSnapshots } from './offline';

const api = axios.create({
  baseURL: '/api',
  timeout: 10000,
  headers: { 'Content-Type': 'application/json' }
});

// Un 401 sur ces routes signifie « mauvais identifiants », pas « session
// expirée » : rediriger rechargerait la page de login et effacerait le message
// d'erreur que l'utilisateur doit lire.
const ROUTES_DE_CONNEXION = ['/auth/login', '/auth/sso'];

api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Seul un 401 veut dire que le serveur a rejeté la session. Une erreur sans
    // `response` n'a jamais atteint le serveur (hors ligne, DNS, timeout) :
    // déconnecter dans ce cas détruirait le token d'un utilisateur légitime dès
    // qu'il perd le réseau une seconde.
    const url = error.config?.url || '';
    const surRouteDeConnexion = ROUTES_DE_CONNEXION.some(r => url.startsWith(r));
    if (error.response?.status === 401 && !surRouteDeConnexion) {
      localStorage.removeItem('token');
      clearSnapshots();
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
